export enum FormErrorMessages {
  NoDSMForSelectedIteration = 'DEM not uploaded for the selected iteration.',
  NoDSMForSelectedSite = 'DEM not uploaded for the selected site.',
  NoDSMForCurrentIteration = 'DEM not uploaded for the current iteration.',
  NoActiveWorkspaceLayer = 'There are no layers in the workspace. Please add layers with polygons and try again',
}
